import React from "react";
import { HelpCircle } from "lucide-react";
import { useStudio } from "@/studio/StudioContext";

// Small "?" button that opens the Manual at a specific section.
export default function InfoDot({ section, label }) {
  const { openManual } = useStudio();
  return (
    <button
      data-testid={`info-${section}`}
      onClick={() => openManual(section)}
      title={label || "Learn more in the Manual"}
      className="w-4 h-4 rounded-full flex items-center justify-center text-neutral-600 hover:text-[#00e5ff] transition-colors shrink-0"
    >
      <HelpCircle size={13} />
    </button>
  );
}
